import { createBoardObjectCollection } from './create'
import { deleteBoardObjectCollection } from './delete'
import { readAllBoardObjectCollections } from './read'
import { isClientResourceId, resourceObject } from './resourceObject'
import { updateBoardObjectCollection } from './update'

export const boardObjectCollections = {
  create: createBoardObjectCollection,
  clientResource: resourceObject,
  isClientResourceId,
  delete: deleteBoardObjectCollection,
  readCollection: readAllBoardObjectCollections,
  update: updateBoardObjectCollection,
}
